export default "__VITE_ASSET__DhQAF9L1__"